<template>
  <loader v-bind="{ loading }">
    <div class="columns">
      <div class="column">
        <text-input v-model="filters.search" classes="is-rounded">
          <template #right>
            <div class="buttons has-addons is-rounded">
              <action-button @click="clearFilters" v-if="filters.search.length" class="is-rounded">
                <icon icon="times"/>
              </action-button>
              <action-button @click="runFilters" class="is-rounded">
                <icon icon="search"/>
                <span>Search</span>
              </action-button>
            </div>
          </template>
        </text-input>
      </div>
    </div>
    <table class="table is-fullwidth is-hoverable">
      <thead>
        <tr>
          <th>Vulnerability</th>
          <th class="has-text-right">Poc</th>
          <th class="has-text-right">Versions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="vulnerability in vulnerabilities.data" :key="vulnerability.id">
          <td>
            <router-link 
              :to="{
                name: 'vulnerability-manager',
                params: {
                  vulnerability: vulnerability.id
                }
              }">
              <span>{{ vulnerability.cvid }}</span>
              <p class="has-text-grey">
                {{ vulnerability.description }}
              </p>
            </router-link>
          </td>
          <td class="is-narrow">
            <span class="tag" :class="{
              'is-danger': !vulnerability.poc_count && vulnerability.requires_poc,
              'is-success': vulnerability.poc_count || !vulnerability.requires_poc
            }">
              <span v-if="vulnerability.poc_count">Has Poc</span> 
              <span v-if="!vulnerability.poc_count && vulnerability.requires_poc">Needs Poc</span> 
              <span v-if="!vulnerability.requires_poc">Updatable</span>
            </span>
          </td>
          <td class="has-text-right is-narrow">{{  vulnerability.versions_count }}</td>
        </tr>
      </tbody>
    </table>
    <pager 
      class="mb-1"
      :pageable="vulnerabilities" 
      @nav="goToPage"
      jump-controls
      context="Vulnerabilities"/>
  </loader>  
</template>
<script>
import Paginator from '@/store/models/Paginator'
import { getPath } from '@/api/common'

export default {
  data: () => ({
    vulnerabilities: new Paginator,
    loading: true,
    filters: {
      search: ''
    }
  }),

  created() {
    if(this.$route.query.search) {
      this.filters.search = this.$route.query.search;
    }
    this.loadVulnerabilities()
  },

  methods: {
    loadVulnerabilities() {
      getPath({
        path: 'api/super' + this.$route.fullPath
      }, ({data}) => {
        this.vulnerabilities = data
        this.loading = false
      }, error => {})
    },
    runFilters() {
      if(!this.filters.search.length) {
        this.$toast.warning('Please enter a search term.')
        return
      }
      this.$router.push({
        name: 'software-vulnerabilities',
        params: {
          software: this.$route.params.software
        },
        query: this.filters
      })
    },
    clearFilters() {
      this.filters.search = ''
      this.$router.push({
        name: 'software-vulnerabilities',
        params: {
          software: this.$route.params.software
        },
        query: this.filters
      })
    },
    goToPage(page) {
      this.$router.push(page)
    }
  },

  watch: {
    '$route': 'loadVulnerabilities'
  }
}
</script>